import React, { Component } from "react";
import {getFavoriteAuthor,removeFavoriteAuthor,addFavoriteAuthor,authorslist_all} from '../config/Variables';
import {defaultimage} from '../config/Settings';
import {baseurl} from '../config/Settings';

export default class FetchUsers extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      messagelog: '',
      loading:true,
      isLoading: true,
      users: [],
      numberstid: [],
      error: null,
      isList: true,
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.Removetid = this.Removetid.bind(this);
  }
  handleInputChange(event) {
    const target = event.target;
    var value = target.value;
    if (target.checked) {
      this.state.hobbies.push(value);
    } else {
      const index = this.state.hobbies.indexOf(value);

      if (index > -1) {
        this.state.hobbies.splice(index, 1);

        this.state.hobbies.splice(index, 1)
        const x = this.state.hobbies.indexOf(value);

        if (this.state.hobbies.indexOf(value) > -1) {
          this.state.hobbies.splice(index, 1);
        } // 2nd parameter means remove one item only
      }
    }
  }

  async Removetid(event) {

    const target = event.target;
    var value = target.value;

    if (event.target.checked) {
      this.state.hobbies.push(value);
      // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
    } else {
      const index = (this.state.hobbies).indexOf(parseInt(value, 2));


      for (var i = 0; i < this.state.hobbies.length; i++) {

        if (this.state.hobbies[i] == value) {
          this.state.hobbies.splice(i, 1);
        }

      }
      if (localStorage.getItem('user-info')) {
        const tid = value

        let item = { tid };
        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(removeFavoriteAuthor, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');

        }
      }
      // this.state.hobbies.splice(value, 1);
    }
  }


  async submit() {
    const tid = this.state.hobbies.join(',')
    const isList = true;
    let item = { tid, isList };
    if (tid == "") {
      this.setState({ messagelog: "اختر الكاتب المفضل لديك" });
    } else {
      if (localStorage.getItem('user-info')) {

        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(addFavoriteAuthor, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: 'personalize_author',
            user_id: user.user.id,
            personalized_authors: tid
            });

          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');
          this.props.samirCallback("success");
        }
      }
    }

  }
  getFetchUsers() {
    let user = JSON.parse(localStorage.getItem('user-info'));
    var numberstid_constant=[];
    var numberstid_hobbies=[];
    
    let datt = fetch(getFavoriteAuthor, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json',
        "Authorization": "Bearer " + user.token.access_token,
      },
      body: JSON.stringify(this.state)
    }).then(response => response.json())
      .then(data => {
        data.data.map(({ tid }, index2) => {
          numberstid_constant.push(tid);
          numberstid_hobbies.push(tid);
        });

        fetch(authorslist_all).then(res => res.json()).then(result => this.setState({
          loading: false,
          users: result.rows,
          numberstid: numberstid_constant,
          hobbies:numberstid_hobbies
        })).catch(console.log);
      });  
  }
  componentDidMount() {
    this.getFetchUsers();
  
  }

  render() {
    const {
      users,
      error,
      loading
    } = this.state;
    
    return (
      <div className="personal-wrap personal-wrap-author"> 
    <div className="personal-wrap-before"> 
        <div className="progress-container">
            <div className="progress" id="progress"></div>
            <div className="progress-circle active">1</div>
            <div className="progress-circle">٢</div>
            <div className="progress-circle">٣</div>
        </div>

        <div className="function-info">
              <h3>تابع كُتابك المفضلين​ ​</h3>
              <p>اختر كُتابك المفضلين لتحصل على مقالاتهم أولاً بأول​</p>
        </div> 

        <div className="select-list">  
            <div className="select-list-inner" id="scroller"> 
                <div className="authors-list inner-scroll">   
                <div className="notif-message"><h3> {this.state.messagelog}</h3></div>
                {loading ? <div className="loading-mypage" > <img src="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/loading-new.gif?ss" /></div>: ""      }
                <React.Fragment>
                  {
                    users.map(({ name, tid, field_opinion_writer_photo_export }, index) => {
                      const fruitss = this.state.numberstid;
                      const ttt = parseInt(tid);
                      const ss = fruitss.includes(ttt); //true
                      if (ss) {
                        return (
                          <div className="author-option" key={index}>
                            <label htmlFor={`custom-checkbox-${index}`} onClick={this.stopLabelPropagation} className="multi-check">
                              <input type="checkbox" id={`custom-checkbox-${index}`}
                                name="hobbies" defaultChecked={true} defaultValue={`${tid}`}
                                className="form-check" onTouchEnd={this.Removetid} onClick={this.Removetid} onChange={this.Removetid} />
                              <div className="author-img round">
                              {field_opinion_writer_photo_export ?
                               <img src={field_opinion_writer_photo_export.startsWith("s3/")?field_opinion_writer_photo_export:field_opinion_writer_photo_export} alt={name} />
                            :<img src={defaultimage} /> }
                              </div>
                              <div className="author-meta">
                                <div className="author-name">{name}</div>
                                <div className="author-desc"><br /></div>
                              </div>
                            </label>
                          </div>
                        );

                      } else {
                        return (
                          <div className="author-option" key={index} onClick={evt => evt.stopPropagation()}>
                            <label htmlFor={`custom-checkbox-${index}`} className="multi-check">
                              <input type="checkbox" id={`custom-checkbox-${index}`}
                                name="hobbies" value={`${tid}`}
                                className="form-check" onChange={this.handleInputChange} />
                              <div className="author-img round">
                              {field_opinion_writer_photo_export ?
                               <img src={field_opinion_writer_photo_export.startsWith("s3/")?field_opinion_writer_photo_export:field_opinion_writer_photo_export}  alt={name} />
                            :<img src={defaultimage} /> }
                              </div>
                              <div className="author-meta">
                                <div className="author-name" >{name}</div>
                                <div className="author-desc"><br /></div>
                              </div>
                            </label>
                          </div>
                        );
                      }
                    })
                  }
                </React.Fragment>
                   
                    
                </div>
            </div>
        </div>
    </div>
    
    <div className="personal-wrap-after">
        <div className="action-btn">
            <button onClick={() => this.submit()} className="button primary rounded next-btn">التالي  </button>
        </div> 
    </div> 
   
</div>);
  }
}
